import type { TranslationTag } from '@ps/web-core-intl';

import { WatchGamesTabs } from '../types/WatchGames';

import {
  TXTCLI_Hall_Of_Fame,
  TXTCLI_LIVE_Now,
  TXTCLI_Recent_Big_Wins
} from './watchGames.messages.json';

export type WatchGamesTabsItems = {
  [key in WatchGamesTabs]: TranslationTag;
};

const TAB_TRANSLATIONS: WatchGamesTabsItems = {
  [WatchGamesTabs.liveNow]: TXTCLI_LIVE_Now,
  [WatchGamesTabs.hallOfFame]: TXTCLI_Hall_Of_Fame,
  [WatchGamesTabs.recentBigWins]: TXTCLI_Recent_Big_Wins
};

export const getInitialSelectedTab = (
  activeTab?: WatchGamesTabs,
  widgetConfigTabs?: WatchGamesTabs[]
) => {
  if (activeTab) {
    return activeTab;
  }

  if (widgetConfigTabs && widgetConfigTabs.length) {
    return widgetConfigTabs[0];
  }

  return WatchGamesTabs.liveNow;
};

export const getAvailableTabs = (widgetConfigTabs?: WatchGamesTabs[]): WatchGamesTabsItems => {
  const availableTabs: WatchGamesTabsItems = { ...TAB_TRANSLATIONS };

  if (widgetConfigTabs?.length) {
    (Object.keys(availableTabs) as WatchGamesTabs[]).forEach((key) => {
      if (!widgetConfigTabs.includes(key)) delete availableTabs[key];
    });
  }

  return availableTabs;
};
